module.exports = __webpack_public_path__ + "fonts/Fontfabric - Uni Sans Bold.3e0aefa0.ttf";